export const NAVIGATE = 'NAVIGATION/NAVIGATE';
export const NAVIGATE_BACK = 'NAVIGATION/NAVIGATE_BACK';
